import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub,
  faFacebook,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import styles from './Header.module.css';

const Header = () => {
  return (
    <div className="mt-3">
      <Navbar expand="lg">
        <Navbar.Brand href="#home">
          <h1 className={styles.logo}>Joney T.</h1>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link className={styles.navItem} as={Link} to="/home">
              Home
            </Nav.Link>
            <Nav.Link className={styles.navItem} href="#portfolio">
              Portfolio
            </Nav.Link>
            <Nav.Link className={styles.navItem} href="#blog">
              Blog
            </Nav.Link>
            <Nav.Link className={styles.navItem} href="#contact">
              Contact
            </Nav.Link>
            <Nav.Link
              style={{ borderLeft: '2px solid gray' }}
              className={styles.navItem}
              target="_blank"
              href="https://www.facebook.com/jony.talukdar.75"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </Nav.Link>
            <Nav.Link
              className={styles.navItem}
              target="_blank"
              href="https://www.linkedin.com/in/joney-miah/"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </Nav.Link>
            <Nav.Link
              className={styles.navItem}
              target="_blank"
              href="https://github.com/jonytalukdar"
            >
              <FontAwesomeIcon icon={faGithub} />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
